let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8RgYl")).then(() => parcelRequire('bis1j'));